// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
function WindowScrollable(Props) {
  var scrollToRef = Props.scrollToRef;
  var children = Props.children;
  var onScroll = Props.onScroll;
  var match = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var useScrollToTimeout = match.setTimeout;
  React.useEffect(function () {
    window.addEventListener("scroll", onScroll, {
      capture: false,
      passive: true,
      once: false
    });
    return function (param) {
      window.removeEventListener("scroll", onScroll, {
        capture: false,
        passive: true
      });
    };
  }, []);
  Belt_Option.forEach(scrollToRef, function (scrollTo) {
    scrollTo.current = function (el0) {
      useScrollToTimeout(function (param) {
        var scrollTop;
        scrollTop = typeof el0 === "number" ? 0.0 : el0.TAG === /* Element */0 ? el0._0.offsetTop : el0._0;
        var options = {
          top: scrollTop,
          left: 0.0,
          behavior: "smooth"
        };
        window.scrollTo(options);
      }, 0);
    };
  });
  return children;
}
WindowScrollable.displayName = "WindowScrollable";
var make = WindowScrollable;
export { make };
/* react Not a pure module */